import React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

interface IProps {
    internalPage: boolean;
    showLogoOnRegistrationScreens?: boolean;
    className?: string;
}
export default function LogoContainer({ internalPage, showLogoOnRegistrationScreens, className }: IProps) {
    const showLogoOnInternalScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.includeLogoOnInternalScreens
            ? state.configurationState.configuration.partnerConfig.includeLogoOnInternalScreens
            : false
    );

    const brandingOptions = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration?.partnerConfig?.brandingOption) {
            return {
                imagePath: state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath,
                associationText: state.configurationState.configuration?.partnerConfig?.brandingOption?.associationText,
                secondaryText: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryText,
            };
        } else {
            return {
                imagePath: "",
                associationText: "",
                secondaryText: "",
            };
        }
    });

    return internalPage && showLogoOnInternalScreens ? (
        <div className="row flex-end col-xs-4" style={{ marginRight: "0px" }}>
            <div className="col-xs col-no-gutter top-nav-hide-mobile flex-grow-null">
                <div className="logo-container">
                    <a role="option" href="dashboard" title="Return to Homepage1" className="logo-link">
                        {/* <img src="images/sontiq_logo_white@2x.png" alt="Sontiq Logo" /> */}
                        <img src={brandingOptions?.imagePath} alt="Logo" />
                    </a>
                </div>
            </div>
        </div>
    ) : showLogoOnRegistrationScreens ? (
            <div role="option" className={`logo-container ${className}`}>
            <img className="logo-link" src={brandingOptions?.imagePath} alt="Logo" />
        </div>
    ) : (
        <></>
    );
}
